'use client';

import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { Alert, Box, Text, TextProps } from '@mezzoforte/forge';
import { useEntryModifiedModal } from '@/hooks/useEntryModifiedModal';

function EntryModified() {
  return (
    <Alert
      mt={3}
      mb={2}
      variant="success"
      data-test="entry-modified-notification"
    >
      <Box>
        <Text
          fontSize="initial"
          lineHeight="inherit"
        >
          Ilmoitusta on muokattu
        </Text>
      </Box>
    </Alert>
  );
}

function ModalOpenText({ children, ...textProps }: TextProps) {
  return (
    <Text
      as="span"
      marginLeft={1}
      color="brand"
      _hover={{ cursor: 'pointer', textDecoration: 'underline' }}
      {...textProps}
    >
      {children}
    </Text>
  );
}

function EntryPublished() {
  const { VatChangedModal, PriceChangedModal, openModal } = useEntryModifiedModal();
  return (
    <Alert
      mt={3}
      mb={2}
      variant="success"
      title="Ilmoitus on julkaistu"
      data-test="entry-published-notification"
    >
      <Box>
        <Text mt={2}>
          Et voi enää muokata
          <ModalOpenText onClick={() => openModal('VAT')}>ALV-kantaan vaikuttavia kenttiä.</ModalOpenText>
        </Text>
        <Text mt={2}>
          Mikäli kohteeseen ei ole tullut tarjouksia, sinulla on vielä mahdollisuus seuraavien 24 tunnin aikana muokata
          <ModalOpenText onClick={() => openModal('Prices')}>
            hintaan vaikuttavia kenttiä, päättymisaikaa tai osastoa.
          </ModalOpenText>
        </Text>
        <Text>
          Tarjouksettomassa kohteessa voit pienentää asettamaasi lähtöhintaa tai minimikorotusta huutokaupan
          päättymiseen asti.
        </Text>
        <VatChangedModal />
        <PriceChangedModal />
      </Box>
    </Alert>
  );
}

export function EntryStatusNotification({ isModified, isPublished }: { isModified: boolean; isPublished: boolean }) {
  const shouldShowNotification = isModified || isPublished;
  const pathName = usePathname();

  useEffect(() => {
    if (shouldShowNotification) {
      window.history.replaceState('', '', pathName);
    }
  }, [shouldShowNotification, pathName]);

  if (!shouldShowNotification) return null;

  return isModified ? <EntryModified /> : <EntryPublished />;
}
